<template>
  <v-container fluid class="pa-0">
    <v-row class="mx-3 mt-4 mb-2 align-center">
      <v-col cols="12" class="pa-0">
        <h1 class="mp-title">Productos y servicios</h1>
        <p class="mp-subtitle mb-0">
          Explora los productos disponibles o revisa tus compras anteriores.
        </p>
      </v-col>
    </v-row>

    <v-tabs v-model="activeTab" color="#1b273e" class="mx-3 mb-4">
      <v-tab>Disponibles</v-tab>
      <v-tab>
        Mis compras
        <v-badge v-if="false" color="primary" inline />
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab">
      <v-tab-item>
        <MemberProductsServicesBlock />
      </v-tab-item>
      <v-tab-item>
        <div class="mx-3">
          <MemberPurchasedProductsBlock />
        </div>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import MemberProductsServicesBlock from "@/components/memberDashboard/MemberProductsServicesBlock.vue";
import MemberPurchasedProductsBlock from "@/components/memberDashboard/MemberPurchasedProductsBlock.vue";

export default {
  name: "MemberProducts",
  components: { MemberProductsServicesBlock, MemberPurchasedProductsBlock },
  data() {
    return { activeTab: 0 };
  },
};
</script>

<style scoped>
.mp-title {
  color: #1b273e;
  font-weight: 800;
  font-size: 1.5rem;
  letter-spacing: -0.01em;
}
.mp-subtitle {
  color: #5b6478;
  font-size: 0.95rem;
}
</style>

